import { Box, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import type { SearchInputProps } from 'app/components';
import { SearchInput, Tooltip } from 'app/components';
import { TranslationKeys } from 'app/translations';

import { CheckboxStyled } from './UsersAccessListHeader.styles';

type UserAccessesListHeaderProps = {
  isLoading: boolean;
  onChange?: SearchInputProps['onChange'];
  headerTextId: string;
  onSelectAll: () => void;
  onSelectAllOnPage: () => void;
  areAllSelected?: boolean;
  areAllOnPageSelected?: boolean;
  noData?: boolean;
  disabled?: boolean;
  totalCount?: number;
  hasSearchQuery?: boolean;
  hideSearch?: boolean;
};

export const UserAccessesListHeader = ({
  onSelectAll,
  onSelectAllOnPage,
  onChange,
  isLoading,
  headerTextId,
  areAllSelected = false,
  areAllOnPageSelected = false,
  disabled = false,
  noData = false,
  totalCount = 0,
  hasSearchQuery = false,
  hideSearch = false,
}: UserAccessesListHeaderProps) => {
  // "select all" would otherwise select every record system-wide, not just the search results shown
  const disableSelectAll = disabled || isLoading || noData || hasSearchQuery;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Typography variant={'h5'} marginLeft={1}>
          <FormattedMessage id={headerTextId} />
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <CheckboxStyled
            name={'select-all-on-page'}
            label={<FormattedMessage id={TranslationKeys.global_selectAllOnPage} />}
            checked={areAllOnPageSelected}
            onChange={onSelectAllOnPage}
            disabled={disabled || isLoading || noData}
          />
          <Tooltip
            title={
              hasSearchQuery ? (
                <FormattedMessage id={TranslationKeys.users_accessesList_selectAllDisabledWhileSearching} />
              ) : (
                <></>
              )
            }
            disableInteractive
          >
            <span>
              <CheckboxStyled
                name={'select-all'}
                label={<FormattedMessage id={TranslationKeys.users_accessesList_grantAccessToAllWithinEnvironment} />}
                checked={areAllSelected}
                onChange={onSelectAll}
                disabled={disableSelectAll}
              />
            </span>
          </Tooltip>
        </Box>
      </Box>

      {!hideSearch && <SearchInput onChange={onChange || (() => undefined)} />}
    </Box>
  );
};
